import { ListItemCheckmark } from '@euler/app/components/list/ListItemCheckmark';
import { Typography } from '@euler/app/components/typography';
import { Separator } from '@euler/app/flows/order/components/Separator';
import { Avatar } from '@euler/components/Avatar';
import { FontFamily } from '@euler/components/typography';
import { getOrgUserRoleTypeLabels } from '@euler/functions/orgUserUtils';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgMember } from '@euler/model/entity';
import { memo } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { useTheme } from 'styled-components';

export const MemberCell = memo(
  ({
    member,
    selected,
    first,
    last,
    isRoleLabelVisible,
    onPress,
  }: {
    member: OrgMember;
    selected?: boolean;
    first?: boolean;
    last?: boolean;
    isRoleLabelVisible?: boolean;
    onPress?: (member: OrgMember) => void;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const roleLabels = isRoleLabelVisible
      ? getOrgUserRoleTypeLabels(member.role)
      : [];
    return (
      <TouchableOpacity
        onPress={() => onPress?.(member)}
        css={`
          flex-direction: row;
          align-items: center;
          flex-wrap: nowrap;
          justify-content: space-between;
          background-color: ${theme.components.card.background};
          padding: ${rpx(15)}px;
        `}
      >
        {first && (
          <Separator
            css={`
              top: 0;
            `}
          />
        )}
        <Separator
          css={`
            bottom: 0;
            left: ${last ? 0 : rpx(15)}px;
          `}
        />
        <Avatar
          name={member.name}
          css={`
            width: ${rpx(32)}px;
            height: ${rpx(32)}px;
            border-radius: ${rpx(16)}px;
            margin-right: ${rpx(10)}px;
          `}
          textStyle={{ fontSize: rpx(17), lineHeight: rpx(28) }}
        />
        <Text
          css={`
            flex: 1;
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(19)}px;
          `}
        >
          {member.name}
        </Text>
        <View
          css={`
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
          `}
        >
          {roleLabels.map((label, i) => (
            <Typography.Label
              key={i}
              size={rpx(12)}
              light
              css={`
                margin-left: ${rpx(3)}px;
                color: #777;
                background-color: #f2f2f2;
                padding: ${rpx(2)}px ${rpx(5)}px;
                border-radius: ${rpx(3)}px;
                overflow: hidden;
              `}
            >
              {label}
            </Typography.Label>
          ))}
          <ListItemCheckmark checked={selected} />
        </View>
      </TouchableOpacity>
    );
  },
);
